




























import ListItem from '@/components/list/ListItem.vue'
import Translation from '@/mixins/Translation'
import {Watch} from '@@/node_modules/vue-property-decorator'
import {Component, Mixins, Prop} from 'vue-property-decorator'
import BttPopup from '@/components/popup/btt/BttPopup.vue'

@Component({
  components: {ListItem, BttPopup},
})
export default class OrderPopup extends Mixins(Translation) {
  @Prop({default: false, type: Boolean}) value: boolean
  @Prop({default: '', type: String}) selectedOrder: string
  @Prop() list: object[]

  open: boolean = true

  isSelected(value) {
    return this.selectedOrder === value
  }

  @Watch('value', {immediate: true})
  __value(value) {
    this.open = value
  }

  @Watch('open', {immediate: true})
  __open(value) {
    this.$emit('input', value)
  }

  onClick(value) {
    this.$emit('select-order', value)
    this.close()
  }

  close() {
    this.open = false
  }
}
